import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { PhoneNumberOption } from '../models/phone-number-option';

export const phoneNumberOptionActions = createEagerSelectActions<PhoneNumberOption>('[Phone Number Options]');
